export const SET_RESULT = 'result/SET';
